document.addEventListener("DOMContentLoaded", function () {
  const container = document.getElementById("gf-quiz-container");
  if (!container) return;

  const sectionData = document.querySelector(".gift-finder-section");
  const baseUrl =
    sectionData.getAttribute("data-collection-url") || "/collections/all";

  let selections = {
    recipient: [],
    occasion: [],
    budget: [],
    gift_type: [],
    flowers: [],
  };
  let triggersFlowerStep = false;

  const cards = document.querySelectorAll(".gf-option-card");
  cards.forEach((card) => {
    card.addEventListener("click", function () {
      const category = this.getAttribute("data-category");
      if (category === "budget") {
        const siblings = this.parentElement.querySelectorAll(".gf-option-card");
        siblings.forEach((s) => s.classList.remove("selected"));
        this.classList.add("selected");
        selections.budget = [this.getAttribute("data-value").trim()];
      } else {
        this.classList.toggle("selected");
        const val = this.getAttribute("data-value").trim();
        if (this.classList.contains("selected")) {
          selections[category].push(val);
          if (this.getAttribute("data-triggers-flower") === "true")
            triggersFlowerStep = true;
        } else {
          selections[category] = selections[category].filter((v) => v !== val);
          if (this.getAttribute("data-triggers-flower") === "true") {
            triggersFlowerStep = Array.from(
              document.querySelectorAll(
                '.gf-option-card[data-category="gift_type"].selected',
              ),
            ).some((c) => c.getAttribute("data-triggers-flower") === "true");
          }
        }
      }
    });
  });

  const nextBtns = document.querySelectorAll(".gf-next:not(.gf-submit)");
  const backBtns = document.querySelectorAll(".gf-back");

  function goToStep(step) {
    document
      .querySelectorAll(".gf-step")
      .forEach((s) => s.classList.remove("active"));
    document.getElementById("gf-step-" + step).classList.add("active");

    document.querySelectorAll(".gf-step-dot").forEach((d) => {
      d.classList.remove("active");
      if (parseInt(d.getAttribute("data-step")) <= step)
        d.classList.add("active");
    });

    document.getElementById("current-step-num").textContent = Math.min(step, 4);
    if (step === 5) {
      document.querySelector(".gf-step-counter").style.display = "none";
      document.querySelector(".gf-progress-container").style.display = "none";
    }
  }

  nextBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      let target = parseInt(this.getAttribute("data-target"));
      if (this.id === "btn-step3-next") {
        if (!triggersFlowerStep) {
          submitQuiz();
          return;
        }
        document.getElementById("gf-dot-4").style.display = "flex";
        document.getElementById("total-steps-num").textContent = "4";
      }
      goToStep(target);
    });
  });

  backBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      // Reload on back from results
      if (
        this.getAttribute("data-target") === "1" &&
        document.getElementById("gf-step-5").classList.contains("active")
      ) {
        return; // inline onclick handles reload
      }
      goToStep(parseInt(this.getAttribute("data-target")));
    });
  });

  document
    .getElementById("gf-submit-btn")
    .addEventListener("click", submitQuiz);

  async function submitQuiz() {
    // Hide all steps, show loader
    document
      .querySelectorAll(".gf-step")
      .forEach((s) => s.classList.remove("active"));
    document.getElementById("gf-loader").style.display = "block";

    // Build ordered list of filters (least important to most important for fallback)
    let allFilters = [];

    // Order: flowers, gift_type, occasion, recipient, budget
    if (selections.flowers.length > 0)
      allFilters.push({
        type: "meta",
        key: "flowers",
        val: selections.flowers[0],
      });
    if (selections.gift_type.length > 0)
      allFilters.push({
        type: "meta",
        key: "gift_type",
        val: selections.gift_type[0],
      });
    if (selections.occasion.length > 0)
      allFilters.push({
        type: "meta",
        key: "occasion",
        val: selections.occasion[0],
      });
    if (selections.recipient.length > 0)
      allFilters.push({
        type: "meta",
        key: "recipient",
        val: selections.recipient[0],
      });
    if (selections.budget.length > 0)
      allFilters.push({
        type: "meta",
        key: "budget",
        val: selections.budget[0],
      });

    let foundHtml = null;
    let matchQuality = "perfect";

    // Progressive Fallback Logic via AJAX
    for (let drop = 0; drop <= allFilters.length; drop++) {
      let activeFilters = allFilters.slice(drop);

      let params = new URLSearchParams();
      activeFilters.forEach((f) => {
        if (f.type === "meta") {
          params.append("filter.p.m.custom." + f.key, f.val);
        }
      });
      params.append("section_id", "gift-finder-quiz");

      let url =
        baseUrl + (baseUrl.includes("?") ? "&" : "?") + params.toString();

      try {
        let res = await fetch(url);
        let html = await res.text();

        if (
          html &&
          !html.includes("gf-no-results") &&
          html.includes("gf-results-grid")
        ) {
          foundHtml = html;
          if (drop > 0 && drop < allFilters.length) matchQuality = "good";
          else if (drop === allFilters.length) matchQuality = "fallback";
          break; // Found results!
        }
      } catch (e) {
        console.error(e);
      }
    }

    // Last resort search
    if (!foundHtml) {
      let res = await fetch("/collections/all?section_id=gift-finder-quiz");
      foundHtml = await res.text();
      matchQuality = "fallback";
    }

    document.getElementById("gf-loader").style.display = "none";

    if (foundHtml) {
      document.getElementById("gf-results-container").innerHTML = foundHtml;

      let sub = document.getElementById("gf-result-subtitle");
      if (matchQuality === "perfect")
        sub.textContent = sub.getAttribute("data-match-perfect") || "We found the perfect match for you!";
      else if (matchQuality === "good")
        sub.textContent = sub.getAttribute("data-match-good") || "We found a great match based on your preferences.";
      else sub.textContent = sub.getAttribute("data-match-fallback") || "Here are our best suggestions for you.";
    } else {
      let container = document.getElementById("gf-results-container");
      container.innerHTML = "<p style='text-align:center; padding: 40px;'>" + (container.getAttribute("data-no-results") || "No results found.") + "</p>";
    }

    goToStep(5);
  }

  document.getElementById("gf-dot-4").style.display = "none";
  document.getElementById("total-steps-num").textContent = "3";
});
